<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="pickerDate" persistent width="290px" :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field outlined rounded dense hide-details="auto" :value="value" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" :clearable="true" @click:clear="onClear" :error-messages="errorMessages" :disabled="disabled"></v-text-field>
    </template>
    <v-date-picker v-model="pickerDate" :type="locationType" scrollable :year-format="yearFormat" :header-date-format="headerDateFormat" :color="color" @input="doFunction">
      <v-spacer></v-spacer>
      <v-btn text :color="color" @click="modal = false"> 取消 </v-btn>
      <v-btn text :color="color" @click="$refs.dialog.save(pickerDate)"> 確認 </v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'FormDatePickerMonth',
  props: {
    value: {
      type: [String, Array],
    },
    type: {
      type: [String],
      default() {
        return 'date';
      },
    },
    format: {
      type: [String],
    },
    errorMessages: {
      type: [String, Array],
    },
    disabled: {
      type: [Boolean],
    },
  },
  data() {
    return {
      color: '#FB966E',
      modal: false,
    };
  },
  computed: {
    locationType() {
      if (this.type === 'date' || this.type === 'month') return this.type;
      return 'date';
    },
    pickerDate: {
      get() {
        if (this.isNullOrEmpty(this.value)) return '';
        if (this.locationType === 'date') {
          return `${Number(this.value.slice(0, 3)) + 1911}-${this.value.slice(3, 5)}-${this.value.slice(5, 7)}`;
        }
        return `${Number(this.value.slice(0, 3)) + 1911}-${this.value.slice(3)}`;
      },
      set(newValue) {
        if (this.isNullOrEmpty(newValue)) {
          this.$emit('input', '');
          return;
        }
        if (this.locationType === 'date') {
          this.$emit('input', `${(Number(newValue.split('-')[0]) - 1911).toString().padStart(3, '0')}${newValue.split('-')[1]}${newValue.split('-')[2]}`);
        } else {
          this.$emit('input', `${(Number(newValue.split('-')[0]) - 1911).toString().padStart(3, '0')}${newValue.split('-')[1]}`);
        }
        // 選擇日期或月份後關閉
        this.$refs.dialog.save(newValue);
      },
    },
  },
  methods: {
    doFunction() {
      this.$emit('doFunction');
    },

    yearFormat(val) {
      return `民國 ${val - 1911} 年`;
    },
    headerDateFormat(val) {
      let dateFormat = `民國 ${Number(val.split('-')[0]) - 1911} 年`;

      if (val.split('-')[1]) {
        dateFormat += ` ${Number(val.split('-')[1])}月`;
      }
      return dateFormat;
    },
    onClear() {
      this.pickerDate = null;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-text-field.v-select .v-input__control .v-input__slot {
  input {
    line-height: initial;
  }
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
  padding: 0 12px;
  background-color: $white;
  .v-input__append-inner {
    height: 100%;
    display: flex;
    align-items: center;
  }
}

::v-deep .v-input__prepend-outer {
  margin-bottom: 0px !important;
  margin-top: 4px !important;
}

::v-deep .v-input__append-inner {
  margin-top: 4px !important;
}

@include phone-width() {
  .w-100 {
    width: 100px;
  }

  .w-200 {
    width: 200px;
  }

  .w-300 {
    width: 300px;
  }

  .w-400 {
    width: 400px;
  }

  .w-500 {
    width: 500px;
  }
}
</style>
